import { render, staticRenderFns } from "./AuditRoomStatus.vue?vue&type=template&id=22e4f98c&"
import script from "./AuditRoomStatus.vue?vue&type=script&lang=ts&"
export * from "./AuditRoomStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports